import { post, getExFile, postFile } from "@utils/httpUtil";

export function findMessageList(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/common/message/findMessageList`, data, config);
}
export function cleanNotReadMessage(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/common/message/cleanNotReadMessage`, data, config);
}
